import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service'

@Component({
  selector: 'app-auth-callback',
  template: '<h1>Signing in ... </h1>'
})
export class LoginCallbackComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {

    if (this.authService.isLoggedIn())
      this.router.navigate(['home']);
    else
      this.router.navigate(['/forbidden']);
  }
}


// WEBPACK FOOTER //
// ./src/app/startup/login-callback.component.ts